export const rules = {
	// Titoli delle carte
	"rules.card.rules.title": "Regole",
	"rules.card.goals.title": "Gol",
	"rules.card.cleanSheets.title": "Porta inviolata",
	"rules.card.cards.title": "Cartellini",
	"rules.card.misc.title": "Varie",
	"rules.card.captains.title": "Capitani e Vice Capitani",
	"rules.card.eligibility.title": "Idoneità e Premi",
	"rules.card.weeklyPrizes.title": "Struttura Premi Settimanali",
	"rules.card.finalRules.title": "Distribuzione Premi e Spareggi",

	// Contenuto delle regole principali
	"rules.intro":
		'Tutti i termini in maiuscolo utilizzati in queste regole (le <strong>"Regole"</strong>) avranno la definizione attribuita loro nei termini e condizioni (i <strong>"Termini e Condizioni"</strong>).',

	"rules.rule1":
		"I partecipanti possono selezionare la loro migliore squadra ogni settimana/turno (a seconda dei casi), relativa alla competizione a cui il gioco Betway Scores BW Fantasy Football si riferisce, ad es. Premier League inglese, ecc. La competizione Betway Scores BW Fantasy Football inizierà l'11 marzo 2025 e si concluderà alla fine della stagione calcistica 2025/2026.",

	"rules.rule2": "Ogni settimana/turno corrisponde ai turni di quella lega.",

	"rules.rule3":
		"I partecipanti possono selezionare un massimo di due (2) giocatori per squadra della lega partecipante da includere nella loro squadra Betway Scores BW Fantasy Football ogni settimana/turno.",

	"rules.rule4":
		"I partecipanti devono selezionare attivamente la loro squadra ogni settimana/turno, con l'opzione di apportare modifiche o scegliere di mantenere la stessa squadra per la settimana/turno successivo.",

	"rules.rule5":
		"I punti vengono assegnati come segue per ciascuna delle seguenti azioni compiute dai giocatori che il Partecipante seleziona nella propria squadra Betway Scores BW Fantasy Football ogni settimana/turno:",

	// Punti gol
	"rules.goals.forwardGoals": "Gol degli attaccanti",
	"rules.goals.forwardGoalsValue": "4",
	"rules.goals.midfielderGoals": "Gol dei centrocampisti",
	"rules.goals.midfielderGoalsValue": "5",
	"rules.goals.defenderGoals": "Gol dei difensori",
	"rules.goals.defenderGoalsValue": "10",
	"rules.goals.goalkeeperGoals": "Gol dei portieri",
	"rules.goals.goalkeeperGoalsValue": "20",
	"rules.goals.penaltyGoals": "Gol su rigore",
	"rules.goals.penaltyGoalsValue": "3",
	"rules.goals.ownGoals": "Autogol",
	"rules.goals.ownGoalsValue": "-5",
	"rules.goals.concededGoals": "Gol subiti",
	"rules.goals.concededGoalsValue": "-1",

	// Punti porta inviolata
	"rules.cleanSheets.goalkeeperCleanSheet": "Porta inviolata del portiere",
	"rules.cleanSheets.goalkeeperCleanSheetValue": "5",
	"rules.cleanSheets.defenderCleanSheet": "Porta inviolata del difensore",
	"rules.cleanSheets.defenderCleanSheetValue": "5",
	"rules.cleanSheets.midfielderCleanSheet": "Porta inviolata del centrocampista",
	"rules.cleanSheets.midfielderCleanSheetValue": "1",

	// Punti cartellini
	"rules.cards.yellowCard": "Cartellini gialli",
	"rules.cards.yellowCardValue": "-2",
	"rules.cards.redCard": "Cartellini rossi",
	"rules.cards.redCardValue": "-5",

	// Punti varie
	"rules.misc.assists": "Assist",
	"rules.misc.assistsValue": "4",
	"rules.misc.shotsOnTarget": "Tiri in porta",
	"rules.misc.shotsOnTargetValue": "1",
	"rules.misc.tackles": "Contrasti",
	"rules.misc.tacklesValue": "2",
	"rules.misc.saves": "Parate",
	"rules.misc.savesValue": "1",
	"rules.misc.minutesOver60": "Minuti giocati pari o superiori a 60",
	"rules.misc.minutesOver60Value": "2",
	"rules.misc.minutesUnder60": "Minuti giocati sotto i 60",
	"rules.misc.minutesUnder60Value": "1",
	"rules.misc.penaltyWon": "Rigore conquistato",
	"rules.misc.penaltyWonValue": "3",
	"rules.misc.penaltiesConceded": "Rigore concesso",
	"rules.misc.penaltiesConcededValue": "-3",
	"rules.misc.penaltyMissed": "Rigore sbagliato",
	"rules.misc.penaltyMissedValue": "-3",
	"rules.misc.offsides": "Fuorigioco",
	"rules.misc.offsidesValue": "-1",
	"rules.misc.foulsCommitted": "Falli commessi",
	"rules.misc.foulsCommittedValue": "-1",

	// Regole capitano
	"rules.rule6":
		'I partecipanti possono assegnare un <strong>"Capitano"</strong> alla loro squadra che riceverà punti 3x. Il Capitano può essere cambiato ogni settimana/turno. Se il Capitano viene cambiato per la settimana/turno successivo o mantenuto per la settimana/turno successivo, deve essere selezionato attivamente ogni settimana/turno dal Partecipante.',

	"rules.rule7":
		'I partecipanti possono assegnare un <strong>"Vice Capitano"</strong> alla loro squadra che riceverà punti 2x. Il Vice Capitano può essere cambiato ogni settimana/turno. Se il Vice Capitano viene cambiato per la settimana/turno successivo o mantenuto per la settimana/turno successivo, deve essere selezionato attivamente ogni settimana dal Partecipante.',

	// Idoneità e premi
	"rules.rule8":
		"Tutti gli utenti registrati di Betway Scores e/o BW Scores sono idonei a giocare a BW Fantasy Football, tuttavia solo i partecipanti con un account Betway verificato, al momento in cui i premi devono essere assegnati, sono idonei a vincere premi. Le modifiche ai risultati dei turni come da punto 2. sopra (che influenzano i punti sotto il 5. sopra) che si verificano dopo l'assegnazione dei premi (ad es. annullamento dei risultati delle partite) non saranno considerate retrospettivamente.",

	"rules.rule9":
		"Il Partecipante qualificato e idoneo che termina la stagione al primo posto e ha un Account Scommesse Betway sarà il vincitore del Gran Premio della stagione e vincerà un viaggio per due (2) per guardare l'Arsenal giocare a Londra, inclusi voli (se necessario), alloggio (se necessario) e £500 per le spese.",

	"rules.rule10":
		"Se il vincitore del Gran Premio della stagione non può viaggiare per non avere un passaporto e/o visto valido e/o altre limitazioni, riceverà un premio di €5.000 di saldo in contanti, o l'equivalente approssimativo nella valuta locale alla data di inizio della competizione (pari a £4.500, R100.000 o GH₵ 60.000), nel proprio Account Betway al completamento della competizione.",

	"rules.rule11":
		"Il vincitore del Gran Premio della stagione può scegliere di non accettare l'esperienza e piuttosto accettare un premio di €5.000 di saldo in contanti, o l'equivalente approssimativo nella valuta locale alla data di inizio della competizione (pari a £4.500, R100.000 o GH₵ 60.000), nel proprio Account Betway.",

	"rules.rule12":
		"I Premi Settimanali saranno assegnati ai primi 10 performer ogni settimana/turno che hanno un Account Scommesse Betway valido. Se uno dei primi 10 performer non ha un Account Scommesse Betway, non riceverà un Premio Settimanale.",

	"rules.rule13":
		"I posti settimanali da 1 a 10 vinceranno i seguenti importi di saldo in contanti, a seconda della regione, nel loro Account Betway:",

	// Intestazioni tabella premi settimanali
	"rules.weeklyPrizes.position": "Posizione Per Turno",
	"rules.weeklyPrizes.eur": "Vincite Saldo Contanti (EUR)",
	"rules.weeklyPrizes.gbp": "Vincite Saldo Contanti (GBP)",
	"rules.weeklyPrizes.zar": "Vincite Saldo Contanti (ZAR)",
	"rules.weeklyPrizes.ghs": "Vincite Saldo Contanti (GHS)",

	// Valori premi settimanali
	"rules.weeklyPrizes.1st.eur": "€150",
	"rules.weeklyPrizes.1st.gbp": "£150",
	"rules.weeklyPrizes.1st.zar": "R3000",
	"rules.weeklyPrizes.1st.ghs": "GH₵ 2000",

	"rules.weeklyPrizes.2nd.eur": "€100",
	"rules.weeklyPrizes.2nd.gbp": "£100",
	"rules.weeklyPrizes.2nd.zar": "R2000",
	"rules.weeklyPrizes.2nd.ghs": "GH₵ 1250",

	"rules.weeklyPrizes.3rd.eur": "€75",
	"rules.weeklyPrizes.3rd.gbp": "£75",
	"rules.weeklyPrizes.3rd.zar": "R1500",
	"rules.weeklyPrizes.3rd.ghs": "GH₵ 1000",

	"rules.weeklyPrizes.4th.eur": "€50",
	"rules.weeklyPrizes.4th.gbp": "£50",
	"rules.weeklyPrizes.4th.zar": "R1000",
	"rules.weeklyPrizes.4th.ghs": "GH₵ 600",

	"rules.weeklyPrizes.5th.eur": "€40",
	"rules.weeklyPrizes.5th.gbp": "£40",
	"rules.weeklyPrizes.5th.zar": "R800",
	"rules.weeklyPrizes.5th.ghs": "GH₵ 500",

	"rules.weeklyPrizes.6th.eur": "€30",
	"rules.weeklyPrizes.6th.gbp": "£30",
	"rules.weeklyPrizes.6th.zar": "R600",
	"rules.weeklyPrizes.6th.ghs": "GH₵ 400",

	"rules.weeklyPrizes.7th.eur": "€20",
	"rules.weeklyPrizes.7th.gbp": "£20",
	"rules.weeklyPrizes.7th.zar": "R400",
	"rules.weeklyPrizes.7th.ghs": "GH₵ 250",

	"rules.weeklyPrizes.8th.eur": "€15",
	"rules.weeklyPrizes.8th.gbp": "£15",
	"rules.weeklyPrizes.8th.zar": "R300",
	"rules.weeklyPrizes.8th.ghs": "GH₵ 200",

	"rules.weeklyPrizes.9th.eur": "€10",
	"rules.weeklyPrizes.9th.gbp": "£10",
	"rules.weeklyPrizes.9th.zar": "R200",
	"rules.weeklyPrizes.9th.ghs": "GH₵ 100",

	"rules.weeklyPrizes.10th.eur": "€10",
	"rules.weeklyPrizes.10th.gbp": "£10",
	"rules.weeklyPrizes.10th.zar": "R200",
	"rules.weeklyPrizes.10th.ghs": "GH₵ 100",

	// Regole finali
	"rules.rule14":
		"I Premi Settimanali saranno assegnati entro 7 (sette) giorni dalla finalizzazione dei risultati di quella settimana e il Gran Premio sarà assegnato entro 7 (sette) giorni dalla conclusione della competizione Betway Scores BW Fantasy Football.",

	"rules.rule15":
		"In caso di parità per i Premi Settimanali, il saldo in contanti per quella posizione (e le posizioni pertinenti sottostanti che sono impattate dalla parità) sarà diviso equamente tra i partecipanti in parità.",

	"rules.rule16":
		"In caso di parità per il Gran Premio, verrà utilizzato un meccanismo di randomizzazione per selezionare solo uno dei partecipanti in parità come vincitore del Gran Premio.",

	"rules.temporary_notice":
		"Si prega di notare che i vincitori dei premi nel periodo dal 19 dicembre 2025 al 2 gennaio 2026 riceveranno i loro premi entro 7 (sette) giorni a partire dal 6 gennaio 2026",
};
